var _slicedToArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/slicedToArray");

var degToRad = function degToRad(d) {
  return d * Math.PI / 180;
};

var coordsToDist = function coordsToDist(lat2, lon2, lat1, lon1) {
  var earthRadius = 6378137;
  var dLat = degToRad(lat2 - lat1);
  var dLon = degToRad(lon2 - lon1);
  lat1 = degToRad(lat1);
  lat2 = degToRad(lat2);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadius * c;
};

module.exports = function (from, to) {
  if (!from) return 0;
  var t1 = from.date / 1000;
  var t2 = to.date / 1000;
  if (!from.value || !to.value) return null;

  var _from$value = _slicedToArray(from.value, 3),
      lat1 = _from$value[0],
      lon1 = _from$value[1],
      ele1 = _from$value[2];

  var _to$value = _slicedToArray(to.value, 3),
      lat2 = _to$value[0],
      lon2 = _to$value[1],
      ele2 = _to$value[2];

  var duration = t2 - t1;
  var distance = coordsToDist(lat2, lon2, lat1, lon1);
  var vertDist = ele2 - ele1;
  var distance3d = Math.sqrt(Math.pow(vertDist, 2) + Math.pow(distance, 2));
  return distance3d / duration;
};